import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('form-section')
class FormSection extends LitElement {
  @property({ }) label?: string;
  @property({ }) icon?: string;
  @property({ type: Number }) step?: number;

  override render() {
    return html`
      <header>
        <h-box class=title>
          ${this.step !== undefined ? html`<div class=step-badge>${this.step}</div>` : nothing}
          ${this.icon ? html`<sl-icon name=${this.icon}></sl-icon>` : nothing}
          ${this.label ? html`<div>${this.label}</div>` : nothing}
          <div><slot name=label></slot></div>
        </h-box>
        <div class=description><slot name=description></slot></div>
      </header>
      <div class=body>
        <slot></slot>
      </div>
    `;
  }

  static styles = [css`
    :host {
      display: block;
    }

    header {
      margin-bottom: var(--sl-spacing-small);
    }
    .title {
      font-weight: var(--sl-font-weight-bold);
      margin-bottom: var(--sl-spacing-small);
      align-items: center;
      gap: var(--sl-spacing-small);
    }
    .description {
      color: var(--sl-color-neutral-500);
    }

    .step-badge {
      box-sizing: border-box;
      width: 1.75rem;
      height: 1.75rem;
      border-radius: 50%;
      background: var(--sl-color-neutral-500);
      color: var(--sl-color-neutral-0);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-weight: var(--sl-font-weight-semibold);
      font-size: var(--sl-font-size-small);
      flex-shrink: 0;
    }

    /* When numbered, indent the section body so it visually hangs off the badge. */
    :host([step]) .body {
      padding-left: calc(1.75rem + var(--sl-spacing-small));
    }
  `];
}